import React from 'react';
import { Tabs } from 'components/ds';
import styled from 'styled-components';

const { TabPane } = Tabs;

interface Tab {
  title: string;
  content: React.ReactNode;
}

interface CustomTabsProps {
  tabs: Tab[];
}

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav::before,
  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-tab {
    border: none !important;
    margin: 0 0 0 0 !important;
    padding: 12px 0 !important;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 10px !important;
  }

  .ant-tabs-tab-btn {
    font-weight: bold;
  }

  .ant-tabs-nav-list {
    padding: 10px 5px;
    border: 2px solid var(--color-background);
    margin: 0 auto;
    border-radius: 100px;
  }
`;

const TabsArround = styled.span<{ isSelected: boolean }>`
  padding: 20px 30px;
  border-radius: 100px;
  color: ${({ isSelected }) => (isSelected ? 'var(--colorTextPrimary)' : 'var(--color-background)')};
  background-color: ${({ isSelected }) => (isSelected ? 'var(--color-background)' : 'transparent')};
`;

const TabsArrounds: React.FC<CustomTabsProps> = ({ tabs }) => {
  const [activeKey, setActiveKey] = React.useState('1');

  const handleTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <StyledTabs defaultActiveKey="1" size="large" activeKey={activeKey} onChange={handleTabChange}>
      {tabs.map((tab, index) => (
        <TabPane
          tab={
            <TabsArround isSelected={activeKey === (index + 1).toString()}>
              {tab.title}
            </TabsArround>
          }
          key={index + 1}
        >
          {tab.content}
        </TabPane>
      ))}
    </StyledTabs>
  );
};

export default TabsArrounds;
